export type WidgetEntityType = "event" | "route" | "location";
export const WidgetEnums = {
	event: "event" as WidgetEntityType,
	route: "route" as WidgetEntityType,
	location: "location" as WidgetEntityType,
};
